import { AddReportButton } from '@/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GeneratePersonalizationSummaryQRCodeModal } from './GeneratePersonalizationSummaryQRCodeModal';

export function GeneratePersonalizationSummaryQRCodeButton() {
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <AddReportButton onClick={() => setOpenModal(true)}>
        {t('reports.personalizationSummaryQRCode.title')}
      </AddReportButton>
      {openModal && (
        <GeneratePersonalizationSummaryQRCodeModal
          onClose={() => setOpenModal(false)}
        />
      )}
    </>
  );
}
